<template>

</template>

<script>
export default {
  name: 'auth-callback',
  created () {
    const fullUrl = window.location;
    const appRootUrl = `${fullUrl.protocol}//${fullUrl.host}${process.env.BASE_URL}`;

    const localJSON = JSON.parse(localStorage.getItem(`oidc.${this.$route.query.state}`));

    this.$oidc.signIn(
      {
        authority: process.env.VUE_APP_AUTHORITY,
        client_id: process.env.VUE_APP_CLIENT_ID,
        response_type: 'code',
        scope: 'offline email openid',
        redirect_uri: `${appRootUrl}callback`,
        extraQueryParams: {
          login_token: localJSON.data,
        },
      }
    );
  }
}
</script>
